import React, { Fragment, useEffect, useState } from 'react';
type CountdownProps = {
  className?: string;
  light?: boolean;
};
export function Countdown({
  className = '',
  light = false
}: CountdownProps) {
  const [seconds, setSeconds] = useState(84034);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: Array<[string, number]> = [['hs', Math.floor(seconds / 3600)], ['min', Math.floor(seconds % 3600 / 60)], ['seg', seconds % 60]];
  return <div className={`inline-flex items-start gap-2 rounded-xl border px-4 py-2 font-mono font-black ${light ? 'border-teal/50 bg-navy text-ink' : 'border-coral/40 bg-[#2B181D] text-[#FFD4D0]'} ${className}`} aria-label="Tiempo restante de la oferta" data-id="element-270" data-mp="1jidav7j285qy">
    {units.map(([label, value], index) => <Fragment key={label} data-id="element-271" data-mp="38tdre2yqgp73" data-mpi={index}>{index > 0 && <span className="pt-1 text-xl opacity-40" data-id="element-272" data-mp="34tvh014jfwii">:</span>}<span className="flex min-w-[36px] flex-col items-center leading-none" data-id="element-273" data-mp="34t25ynyjqkuk"><b className="text-xl" data-id="element-274" data-mp="2c8ghuoeo7u82">{String(value).padStart(2, '0')}</b><small className="mt-1 font-sans text-[9px] font-bold uppercase tracking-wider opacity-70" data-id="element-275" data-mp="2c9zxqdwf039b">{label}</small></span></Fragment>)}
  </div>;
}